<template>
    <el-dialog
        :class="['lnk-export-dialog',themeClass]"
        :title="$t('LnkExportPick.title')"
        append-to-body
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        :visible.sync="dialogShow"
        width="600px"
        @close="closeDialog"
        @open="handleOpen">
        <el-table border ref="multipleTable" :data="tableData" tooltip-effect="dark" header-cell-class-name="headerCellStyle" cell-class-name="cellStyle" style="width: 100%" @select-all="selectAllChange" @select="selectChange">
            <el-table-column type="selection" width="40px"></el-table-column>
            <el-table-column type="index" :label="$t('LnkExportPick.fieldIndex')" width="50px"></el-table-column>
            <el-table-column prop="name" :label="$t('LnkExportPick.fieldName')" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column prop="field" :label="$t('LnkExportPick.fieldField')" min-width="120" show-overflow-tooltip></el-table-column>
            <el-table-column :label="$t('global.operation')" width="150px">
                <template slot-scope="scope">
                    <div :class="getClassName">
                        <el-button size="mini" type="text" @click="setTop(scope.$index)">{{$t('LnkExportPick.btnTotop')}}</el-button>
                        <span class="icon-upright">|</span>
                        <el-button size="mini" type="text" @click="setUp(scope.$index)">{{$t('LnkExportPick.btnUpwards')}}</el-button>
                        <span class="icon-upright">|</span>
                        <el-button size="mini" type="text" @click="setDown(scope.$index)">{{$t('LnkExportPick.btnDownwards')}}</el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div slot="footer" class="dialog-footer" :class="getClassName">
            <el-row>
                <el-col :span="8">
                    <el-input class="inputCode" v-model="input" size="mini" :placeholder="$t('LnkExportPick.placeholderFilename')"></el-input>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="value" size="mini" :placeholder="$t('LnkExportPick.placeholderFiletype')" disabled>
                        <el-option key="0" label=".CSV" value="0"></el-option>
                        <el-option key="1" label=".xls" value="1"></el-option>
                        <el-option key="2" label=".xlsx" value="2"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="12" style="text-align: right">
                    <el-button size="mini" type="primary" @click="closeDialog">{{$t('global.cancel')}}</el-button>
                    <el-button size="mini" type="primary" @click="mySubmit('current')">{{$t('LnkExportPick.btnExportcrt')}}</el-button>
                    <el-button size="mini" type="primary" @click="mySubmit('all')">{{$t('LnkExportPick.btnExportall')}}</el-button>
                </el-col>
            </el-row>
        </div>
    </el-dialog>
</template>

<script>
import themeClass from '@mixins/theme-class';
export default {
    name: 'lnk-export-pick',
    mixins: [themeClass],
    data: function(){
        return {
            input: '', // 导出文件名称输入框存值。
            value: '.CSV', // 导出文件类型选择框存值。
            tableData: this.data,// 列表内容原始存值。
            dialogShow: this.exportDialog //弹出框的显示
        };
    },

    /** 组件与外界数据交流。*/
    props: {
        // 控制弹出框显示与隐藏。
        exportDialog: {
            type: Boolean,
            // required: true,
            default(){
                return false;
            }
        },
        // 外部接收的data数据，用于组件列表展示。
        data: {
            type: Array
            // required: true
        },
        // 外部接收的数据，用来改变dms和crm下不同的样式表现。
        styleType: {
            type: String,
            default: 'dms'
        }
    },
    watch: {
        // 监听外部data的变化，从而改变内部tableData的变化。
        data: {
            handler: function(val){
                if(this.tableData !== val){
                    this.tableData = val;
                }
            },
            deep: true
        },
        exportDialog: {
            immediate: true,
            handler: function (val) {
                this.dialogShow = Boolean(val);
            }
        }
    },

    /** 计算属性。*/
    computed: {

        /** 通过标识，判断模块运用在crm或dms中，并显示与之相对应的样式。*/
        getClassName(){
            if(this.styleType == 'crm'){
                return 'crm-color';
            }else{
                return '';
            }
        }
    },

    /** 方法模块。*/
    methods: {

        /** 交换数组元素,
             * 参数arr：对应的数组；index1：当前列表行的索引值；index2：目标列表行的索引值。
             * */
        swapItems(arr, index1, index2) {
            arr[index1] = arr.splice(index2, 1, arr[index1])[0];
            return arr;
        },

        /** 列表顺序上移。
             * index: 当前数据的下标值。
             * */
        setUp(index){
            if(index == 0) {
                return;
            }
            this.tableData = this.swapItems(this.tableData, index, index - 1);
        },

        /** 列表顺序下移。
             * index: 当前数据的下标值。
             * */
        setDown(index){
            if(index == this.tableData.length -1) {
                return;
            }
            this.tableData = this.swapItems(this.tableData, index, index + 1);
        },

        /** 列表顺序置顶。
             * index: 当前数据的下标值。
             * */
        setTop(index){
            for(var i=index; i>=0; i--){
                this.setUp(i);
            }
        },

        /** 点击单个项，列表多选时，为每个选中的项上添加checked标识。
             * list: 返回当前被选中的列表数组。
             * val: 多选的数据list。
             * */
        selectChange(list, val){
            if(val.checked === true){
                val.checked = false;
            }else{
                val.checked = true;
            }
        },

        /** 监控dialog打开之前调用的方法，设置默认全选*/
        handleOpen(){
            this.$nextTick(function(){
                this.toggleAllSelection();
            });
        },

        /** 设置全选调用函数。*/
        toggleAllSelection(){
            var _this = this;
            this.tableData.forEach(function (row) {
                _this.$refs.multipleTable.toggleRowSelection(row);
            });
            this.selectAllChange(this.tableData);
        },

        /** 点击全选或全不选时，为每个选中的项上添加或删除checked标识。
             * list: 返回当前被选中的列表数组。
             * */
        selectAllChange(list){
            if(list.length === 0){
                for(var i = 0; i < this.tableData.length; i++){
                    if(this.tableData[i].checked !== undefined){
                        delete this.tableData[i].checked;
                    }
                }
            }else{
                for(var i = 0; i < this.tableData.length; i++){
                    this.tableData[i].checked = true;
                }
            }
        },

        /** 关闭弹框使组件内的exporDialog值变成false。*/
        closeDialog(){
            this.dialogShow = false;
            this.$emit('update:exportDialog', false);
        },

        /** 导出按钮。
             * val: 标识是到处当前页（current）或是导出全部（all）。
             * */
        mySubmit(val) {
            var arr = [];
            for(var i = 0; i < this.tableData.length; i++){
                if(this.tableData[i].checked === true){
                    arr.push(this.tableData[i]);
                }
            }
            var isForm = true;
            if(arr.length == 0){
                isForm = false;
                this.$message.warning('请选择导出项');
            }else if(this.value == ''){
                isForm = false;
                this.$message.warning('请选择文件类型');
            }
            for(var j = 0; j < arr.length; j++){
                delete arr[j].checked;
            }
            if(isForm){
                var obj ={
                    fileName: this.input,
                    fileType: this.value,
                    fields: arr,
                    range: val
                };
                this.$emit('submit-success', obj);
                this.$refs.multipleTable.clearSelection();
                this.input = '';
                this.closeDialog();
            }
        }
    }
};
</script>

<style>
    .lnk-export-dialog .crm-color .el-button--primary{
        background-color: #2E5BFF;
        border-color: #2E5BFF;
    }
    .lnk-export-dialog .crm-color .el-button--text{
        color: #2E5BFF;
    }
    .lnk-export-dialog .crm-color .icon-upright{
        color: #2E5BFF!important;
    }
    .lnk-export-dialog .el-dialog__title{
        font-weight: normal;
    }
    .lnk-export-dialog .el-dialog__headerbtn{
        top: 10px;
    }
    .lnk-export-dialog .el-dialog__body{
        line-height: 12px;
        background-color: #F8F9FA;
        padding: 8px 16px;
    }
    .lnk-export-dialog .el-table__body-wrapper{
        height: 370px;
        overflow-y: auto;
    }
    .lnk-export-dialog .el-dialog__body .icon-upright{
        margin: 0 4px;
        color: #2E5BFF;
    }
    .lnk-export-dialog .dialog-footer{
        text-align: left;
        padding: 0 16px;
    }
    .lnk-export-dialog .dialog-footer .inputCode .el-input__inner{
        border-right: none;
    }
    .lnk-export-dialog .dialog-footer .el-button{
        width: 80px;
        min-width: initial!important;
        height: 28px;
        line-height: 28px;
    }
    .lnk-export-dialog .headerCellStyle{
        font-size: 12px;
        color: #384250;
        border-right: none;
        padding: 6px 0;
        background-color: #F6F7FB;
    }
    .lnk-export-dialog .cellStyle{
        font-size: 12px;
        color: #384250;
        border-right: none;
        padding: 6px 0;
    }
    .lnk-export-dialog .el-table .cell .el-button--text{
        color: #2E5BFF!important;
    }
</style>
